import { PageInfo } from "../../../models";

export function calculateChunksCountOnPage(totalRows: number, pageNumber: number, rowsPerPage: number): number {
  const startRow = (pageNumber - 1) * rowsPerPage + 1;
  const endRow = Math.min(pageNumber * rowsPerPage, totalRows);
  const rowsOnPage = endRow - startRow + 1;
  return rowsOnPage > 0 ? rowsOnPage : 0;
}

export function calculatePageInfo(pageInfo: PageInfo): PageInfo {
  const maxChunksCount = Math.ceil(pageInfo.rowsPerPage / pageInfo.rowsPerChunk);
  const totalChunksCount = Math.ceil(pageInfo.totalRows / pageInfo.rowsPerChunk);
  const maxChunksInCurrentPage = calculateChunksCountOnPage(totalChunksCount, pageInfo.currentPageIndex + 1, maxChunksCount);

  return {
    ...pageInfo,
    totalPages: Math.ceil(pageInfo.totalRows / pageInfo.rowsPerPage),
    maxChunksInCurrentPage: maxChunksInCurrentPage
  };
}
